import {
  Alert,
  AlertIcon,
  Button,
  CloseButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  AlertTitle,
  ModalOverlay,
  Text,
  useToast,
} from "@chakra-ui/react";
import React, { useMemo } from "react";
import { FormField } from "../form/formField/FormField";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import axios from "axios";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  notification: any;
}

const notificationSchema = Yup.object({
  templateName: Yup.string().required("Required"),
  title: Yup.string().required("Required"),
  message: Yup.string().required("Required"),
});

const SendNotificationsModal: React.FC<Props> = ({
  isOpen,
  onClose,
  notification,
}) => {
  const initialValue = useMemo(() => {
    if (notification) {
      return {
        templateName: notification.template_name,
        title: notification.title,
        message: notification.message,
      };
    } else {
      return {
        templateName: "New Flash offer",
        title: "New Flash offer",
        message: "book your hungry table for 50% discount",
      };
    }
  }, []);
  const toast = useToast();

  const onSubmit = (values: Record<string, any>) => {
    // Handle notification sending logic here
    // console.log("Sending notification:", values);
    if (notification._id) {
      axios({
        method: "post",
        url: `${process.env.REACT_APP_BASE_URL}/admin/notification/send-to-user/${notification._id}`,
      })
        .then((response) => {
          onClose(); // Optionally close the drawer on submit
          toast({
            title: "Notification sent successfully",
            status: "success",
            duration: 3000,
            isClosable: true,
          });
        })
        .catch((error) => {
          toast({
            title: "Failed to send notification",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          console.error("API Error:", error);
          onClose();
        });
    }
    // onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Send notifications</ModalHeader>
        <ModalCloseButton />
        <Formik
          initialValues={initialValue}
          validationSchema={notificationSchema}
          onSubmit={onSubmit}
        >
          {({ values, errors, touched, submitForm }) => (
            <Form>
              <ModalBody>
                <FormField
                  required={false}
                  disabled={true}
                  name="Template name"
                  fieldName="templateName"
                  placeholder="Enter template name"
                  type="text"
                  error={
                    touched.templateName
                      ? (errors.templateName as string)
                      : undefined
                  }
                />
                <FormField
                  required={false}
                  disabled={true}
                  name="Title"
                  fieldName="title"
                  placeholder="Enter title"
                  type="text"
                  error={touched.title ? (errors.title as string) : undefined}
                />
                <FormField
                  required={false}
                  disabled={true}
                  name="Message"
                  fieldName="message"
                  placeholder="Enter message"
                  type="textarea"
                  error={
                    touched.message ? (errors.message as string) : undefined
                  }
                />
              </ModalBody>
              <ModalFooter>
                <Button variant="outline" mr={3} onClick={onClose}>
                  Cancel
                </Button>
                <Button colorScheme="red" onClick={submitForm}>
                  Send notifications
                </Button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </ModalContent>
    </Modal>
  );
};

export default SendNotificationsModal;
